import { combineReducers } from "redux";
import templateContents from "./templateContentReducer";
import cmsPageReducer from "./cmsPageReducer";
import loadingReducer from "./loadingReducer";
import languageToggleReducer from "./languageToggleReducer";
import navigationReducer from "./navigationReducer";
import footerReducer from "./footerReducer";
import searchParamsReducer from "./searchParamsReducer";

const akashaReducer = combineReducers({
  templateContents,
  page: cmsPageReducer,
  navigation: navigationReducer,
  footerLinks: footerReducer,
  isLoading: loadingReducer,
  language: languageToggleReducer,
  searchParams: searchParamsReducer
});

export default akashaReducer;
